import React, { FC, useContext } from 'react'
import { Trans, t } from '@lingui/macro'
import { Modal } from '../../../components/common/modal/Modal'
import { notification } from '../../../components/common/notifications/Notifications'
import { useArchiveWorkbookMutation } from './WorkbooksAnalytics.codegen'
import { AnalyticsContext } from '../AnalyticsContext'
import { ButtonDanger, ButtonLight } from 'front-end/src/components'

interface IProps {
  workbookId: number
  onCanceled?: () => void
  onArchived?: () => void
}

const WorkbookArchiveModal: FC<IProps> = ({
  workbookId,
  onArchived,
  onCanceled
}: IProps) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)
  const [archiveWorkbook, { loading: isDeleting }] =
    useArchiveWorkbookMutation()

  const onClickArchive = async (): Promise<void> => {
    try {
      await archiveWorkbook({
        variables: { workbookId, filter: filterAsQueryVariables }
      })
      notification.info(t`Enrolment has been archived`)
      onArchived && onArchived()
    } catch (e) {
      notification.error(t`Error archiving user enrolment`)
    }
  }

  const renderControls = (): JSX.Element => {
    return (
      <>
        <ButtonLight onClick={onCanceled}>Cancel</ButtonLight>
        <ButtonDanger
          isLoading={isDeleting}
          onClick={onClickArchive}
          dataTest="ArchiveEnrolmentModalButton"
        >
          <Trans>Archive this enrolment</Trans>
        </ButtonDanger>
      </>
    )
  }

  return (
    <Modal
      header={t`Archive user enrolment`}
      show
      controls={renderControls()}
      onHide={onCanceled}
    >
      <p>
        <Trans>
          Are you sure you want to archive this enrolment?
          <br />
          This will archive all record of this activity. This action cannot be
          undone
        </Trans>
      </p>
    </Modal>
  )
}

export default WorkbookArchiveModal
